import $ from 'jquery';

// Require plugins
require('slick-carousel');

$(document).ready(() => {
	const $status = $('.offer-slider__status');
	const $slider = $('.offer-slider');

	$slider.on('init reInit afterChange', (event, slick, currentSlide) => {
		// currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
		const i = (currentSlide || 0) + 1;
		$status.text(`${i}/${slick.slideCount}`);
	});

	$slider.on('touchend touchcancel touchmove', function () {
		$(this).slick('slickPlay');
	});

	$slider.slick({
		arrows: false,
		autoplay: true,
		pauseOnFocus: false,
		pauseOnHover: false,
	});
});
